import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoDirective, TranslocoModule } from '@jsverse/transloco';
import { TranslocoService } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-user-agreement',
  standalone: true,
  imports: [RouterLink, TranslocoDirective, TranslocoModule, CommonModule],
  templateUrl: './user-agreement.html',
  styleUrl: '../../../styles.css',
})
export class UserAgreementComponent {
  constructor(
    private readonly translocoService: TranslocoService
  ) {}
  
  changelanguage(lang: string) {
    this.translocoService.setActiveLang(lang);
  }
}
